<template>
  <el-dialog
    v-model="dialogFormVisible"
    :close-on-click-modal="false"
    title="配置"
    width="700px"
    @close="close"
  >
    <el-form ref="form" label-width="80px" :model="form" :rules="rules">
      <el-form-item
        :label="index == 0 ? '自定义表单' : ''"
        v-for="(item, index) of form.orderExtraInfo"
        :key="index"
      >
        <el-col :span="10">
          <el-form-item
            :ref="index + 'title'"
            :prop="'orderExtraInfo.' + index + '.title'"
            :rules="item.titleRules"
          >
            <el-input v-model="item.title" placeholder="请输入名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10" style="margin-left: 20px">
          <el-form-item
            :ref="index + 'require'"
            :prop="'orderExtraInfo.' + index + '.require'"
            :rules="item.requireRules"
          >
            <el-radio-group v-model="item.require">
              <el-radio :label="1">必填</el-radio>
              <el-radio :label="0">选填</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-button
            style="margin-left: 20px"
            type="primary"
            @click="addPrice"
            v-if="index == 0"
          >
            添加
          </el-button>
          <el-button
            style="margin-left: 20px"
            type="primary"
            v-if="index !== 0"
            @click="delPrice(index)"
          >
            删除
          </el-button>
        </el-col>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { setupConfig, getConfig } from '@/api/apartment'

export default {
  name: 'SetupEdit',
  emits: ['fetch-data'],
  data() {
    return {
      form: {
        orderExtraInfo: [
          {
            title: '',
            require: 0,
            titleRules: [
              { required: true, trigger: 'blur', message: '请输入标题' },
            ],
            requireRules: [
              { required: true, trigger: 'blur', message: '请选择是否必填' },
            ],
          },
        ],
      },
      rules: {},
      title: '',
      dialogFormVisible: false,
    }
  },
  mounted() {
    // this.getConfig()
  },
  methods: {
    async getConfig() {
      const ret = await getConfig({ key: 'APARTMENT' })
      if(!ret||ret.basic.orderExtraInfo==0) return
      const list = ret.basic&&ret.basic.orderExtraInfo || []
      list.forEach(item=>{
        item.titleRules = [
            { required: true, trigger: 'blur', message: '请输入标题' },
          ]
          item.requireRules = [
            { required: true, trigger: 'blur', message: '请选择是否必填' },
          ]
      })
      this.form.orderExtraInfo = list
    },
    // 设置价格
    addPrice() {
      this.form.orderExtraInfo.push( {
            title: '',
            require: 0,
            titleRules: [
              { required: true, trigger: 'blur', message: '请输入标题' },
            ],
            requireRules: [
              { required: true, trigger: 'blur', message: '请选择是否必填' },
            ],
          })
    },
    delPrice(index) {
      this.form.orderExtraInfo.splice(index, 1)
    },
    async showEdit(row) {
      this.getConfig()
      this.dialogFormVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        const data = Object.assign({}, this.form)
        data.orderExtraInfo.forEach((e) => {
          delete e['titleRules']
          delete e['requireRules']
        })
        if (valid) {
          await setupConfig(data)
          this.$baseMessage(
            '保存配置成功',
            'success',
            false,
            'vab-hey-message-success'
          )
          this.$emit('fetch-data')
          this.close()
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style style="scss" scoped>
</style>
